module.exports = __webpack_public_path__ + "static/media/server.b78655b3.png";